import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { HelpersService } from '../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { CouponsService } from '../../../../../services/coupons.service';
import { InvoiceService } from '../../../../../services/invoice.service';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-coupon-detail',
  templateUrl: './coupon-detail.component.html',
  styleUrls: ['./coupon-detail.component.scss'],
})
export class CouponDetailComponent implements OnInit {
  @Input() coupon;
  @Input() isRentals;
  @Input() isWorkshop;
  @Output() close = new EventEmitter();
  public partner: any = {};
  public editing: boolean = false;
  public editingCouponCode: boolean = false;
  public loading: boolean = false;
  public loadingLookupData: boolean = false;
  public saving: boolean = false;
  public expired: boolean = false;
  public couponExists: boolean = false;
  public redeemMethodOptions: any = [
    {
      value: 'ANY',
      label: this.translate.instant('bikeshop.coupons.any_platform'),
    },
    { value: 'APP', label: this.translate.instant('bikeshop.coupons.app') },
    {
      value: 'WIDGET',
      label: this.translate.instant('bikeshop.coupons.online_widget'),
    },
  ];
  public types: any = [
    {
      value: 'FIXED_VALUE',
      label: this.translate.instant('bikeshop.coupons.fixed_value'),
    },
    {
      value: 'PERCENT',
      label: this.translate.instant('bikeshop.coupons.percent'),
    },
  ];
  public productCategories: any = [];
  public serviceTypes: any = [];

  public affiliates: any = [];
  public rentalCategories: any = [];
  public rentalAccessoryCategories: any = [];
  public specificDays: any = [];

  public selectedServiceTypes: any;
  public selectedProductCategories: any;
  public selectedRentalCategories: any;
  public selectedRentalAccessoryCategories: any;
  public selectedRentalAffiliates: any;
  public selectedRentalDays: any;
  public limitDate: boolean = false;
  public limitUsage: boolean = false;
  public linkedToParent: boolean = false;
  public showAddUser: boolean = false;
  public lightSpeedDiscountOpitons: any = [];
  public isLightSpeed: boolean = false;
  public countryData: any = {};

  public tab: number = 0;
  public step = 1;
  @ViewChild('fileUpload') fileUpload: any;
  public isExcelFile: boolean;
  public keys: string[];
  public data: any[];
  public dataSheet = new Subject();
  public invalidFileFormat = false;
  public hasValidationErrors = false;
  public sheetData: any = [];
  public progress: number = 0;
  public columns: any = [
    //{ header: this.translate.instant('general.headers.coupons.coupon_code'), field: 'couponCode', type: 'string' },
    //{ header: this.translate.instant('general.headers.coupons.redeem_method'), field: 'redeemMethod', type: 'string' },
    {
      header: this.translate.instant('general.headers.coupons.linked_to'),
      field: 'jobCard',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.coupons.value'),
      field: 'discountValue',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.coupons.expiry_date'),
      field: 'expiryDate',
      type: 'date',
    },
    { header: '', field: 'status', type: '' },
  ];

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 250;

  constructor(
    private helpersService: HelpersService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    public messageService: MessageService,
    private invoiceService: InvoiceService,
    private couponsService: CouponsService,
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  inputChanged() {
    this.modelChanged.next('');
  }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.countryData = this.helpersService.getCountryData();

    if (this.partner.POSSystemID === 6) {
      this.isLightSpeed = true;
      this.getLightSpeedDiscountIDs();
    }

    this.subscription = this.modelChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.checkCouponExists();
      });

    if (this.coupon.id) {
      this.editing = true;
      this.expired = this.coupon.expired;
      this.limitDate =
        this.coupon.expiryDate && this.coupon.expiryDate.length > 0;
      this.limitUsage = this.coupon.usageTimes && this.coupon.usageTimes > 0;
      this.linkedToParent =
        this.coupon.partnerParentID && this.coupon.partnerParentID > 0;

      if (this.coupon.expiryDate) {
        this.coupon.expiryDate = moment(this.coupon.expiryDate).toDate();
      }

      this.getFullDetail();
    }

    this.getLookupData();
  }

  getLightSpeedDiscountIDs() {
    this.invoiceService.getDiscounts(this.partner.ID).subscribe((discounts) => {
      console.log(discounts);
      this.lightSpeedDiscountOpitons = discounts.map((discount) => {
        return {
          value: parseInt(discount.ID),
          label: discount.Name,
          discountPercent: parseFloat(discount.DiscountPercent),
          discountAmount: parseFloat(discount.DiscountAmount),
        };
      });
    });
  }

  getLookupData() {
    this.loadingLookupData = true;
    if (this.isRentals) {
      this.couponsService.getRentalsLookupData(this.partner.ID).subscribe(
        (lookupData) => {
          this.affiliates = lookupData.affiliates;
          this.rentalCategories = lookupData.rentalCategories;
          this.rentalAccessoryCategories = lookupData.rentalAccessoryCategories;
          this.specificDays = lookupData.specificDays;

          this.loadingLookupData = false;
        },
        (err) => {
          this.loadingLookupData = false;
        },
      );
    } else {
      this.couponsService.getLookupData(this.partner.ID).subscribe(
        (lookupData) => {
          this.productCategories = lookupData.productCategories.map(
            (productCategory) => {
              return {
                label: productCategory.productCategory,
                value: productCategory.productCategory,
              };
            },
          );

          var serviceTypes = lookupData.serviceTypes;
          var groupName = '';
          serviceTypes.map((serviceType) => {
            serviceType.groupName = serviceType.groupName
              ? serviceType.groupName
              : this.translate.instant('general.not_grouped');
            if (serviceType.groupName !== groupName) {
              groupName = serviceType.groupName;
              this.serviceTypes.push({
                label: serviceType.groupName,
                value: -1,
                disabled: true,
              });
            }
            if (serviceType.linkedToSKU) {
              this.serviceTypes.push({
                label: serviceType.serviceType,
                value: serviceType.id,
              });
            }
          });
          this.loadingLookupData = false;
        },
        (err) => {
          this.loadingLookupData = false;
        },
      );
    }
  }

  getFullDetail() {
    this.loading = true;
    if (this.isRentals) {
      this.couponsService
        .getRentalCouponDetail(this.partner.ID, this.coupon.id)
        .subscribe(
          (coupon) => {
            this.coupon = coupon;

            this.expired = this.coupon.expired;
            this.limitDate =
              this.coupon.expiryDate && this.coupon.expiryDate.length > 0;
            this.limitUsage =
              this.coupon.usageTimes && this.coupon.usageTimes > 0;
            this.linkedToParent =
              this.coupon.partnerParentID && this.coupon.partnerParentID > 0;

            if (this.coupon.expiryDate) {
              this.coupon.expiryDate = moment(this.coupon.expiryDate).toDate();
            }

            if (this.coupon.linkedToRentalCategories) {
              this.selectedRentalCategories =
                this.coupon.couponRentalCategories.map((item) => {
                  return item.categoryID;
                });
            }
            if (this.coupon.linkedToRentalAccessoryCategories) {
              this.selectedRentalAccessoryCategories =
                this.coupon.couponRentalAccessoryCategories.map((item) => {
                  return item.categoryID;
                });
            }
            if (this.coupon.linkToAffiliates) {
              this.selectedRentalAffiliates = this.coupon.couponAffiliates.map(
                (item) => {
                  return item.affiliateID;
                },
              );
            }
            if (this.coupon.specifySpecificDays) {
              this.selectedRentalDays = this.coupon.couponSpecificDays.map(
                (item) => {
                  return item.dayOfWeek;
                },
              );
            }

            if (this.coupon.expiryDate) {
              this.coupon.expiryDate = moment(this.coupon.expiryDate).toDate();
            }
            this.loading = false;
            console.log(this.coupon);
          },
          (err) => {
            this.loading = false;
          },
        );
    } else {
      this.couponsService
        .getCouponDetail(this.partner.ID, this.coupon.id)
        .subscribe(
          (coupon) => {
            this.coupon = coupon;

            this.expired = this.coupon.expired;
            this.limitDate =
              this.coupon.expiryDate && this.coupon.expiryDate.length > 0;
            this.limitUsage =
              this.coupon.usageTimes && this.coupon.usageTimes > 0;
            this.linkedToParent =
              this.coupon.partnerParentID && this.coupon.partnerParentID > 0;

            if (this.coupon.expiryDate) {
              this.coupon.expiryDate = moment(this.coupon.expiryDate).toDate();
            }

            if (this.coupon.linkToServiceTypes) {
              this.selectedServiceTypes = this.coupon.linkedServiceTypes.map(
                (item) => {
                  return item.serviceTypeID;
                },
              );
            }
            if (this.coupon.linkedToProductCategories) {
              this.selectedProductCategories =
                this.coupon.linkedProductCategories.map((item) => {
                  return {
                    label: item.productCategory,
                    value: item.productCategory,
                  };
                });
            }

            if (this.coupon.expiryDate) {
              this.coupon.expiryDate = moment(this.coupon.expiryDate).toDate();
            }
            this.loading = false;
            console.log(this.coupon);
          },
          (err) => {
            this.loading = false;
          },
        );
    }
  }

  parentToggled() {
    if (this.linkedToParent) {
      this.coupon.linkToServiceTypes = false;
    }
  }

  checkCouponExists() {
    if (
      !this.editing &&
      this.coupon.couponCode &&
      this.coupon.couponCode.length > 0
    ) {
      this.couponsService
        .checkCouponCodeExists(
          this.partner.ID,
          this.coupon.couponCode,
          this.isRentals ? 'RENTALS' : 'WORKSHOP',
        )
        .subscribe((exists) => {
          this.couponExists = exists.couponExists;
        });
    } else {
      this.couponExists = false;
    }
  }

  valid() {
    var fixed =
      this.coupon.type === 'FIXED_VALUE'
        ? this.coupon.fixedValue !== null && this.coupon.fixedValue > 0
        : true;
    var percent =
      this.coupon.type === 'PERCENT'
        ? this.coupon.percentValue !== null && this.coupon.percentValue > 0
        : true;
    var limitDate = this.limitDate
      ? this.coupon.expiryDate !== null && this.coupon.expiryDate !== ''
      : true;
    var limitUsage = this.limitUsage
      ? this.coupon.usageTimes !== null && this.coupon.usageTimes > 0
      : true;

    var numberRentalProductsToQualify =
      this.coupon.numberRentalProductsToQualify < 0 ||
      this.coupon.numberRentalProductsToQualify === null
        ? false
        : true;
    var minimumRentalSpendToQualify =
      this.coupon.minimumRentalSpendToQualify < 0 ||
      this.coupon.minimumRentalSpendToQualify === null
        ? false
        : true;

    return (
      fixed &&
      percent &&
      limitDate &&
      limitUsage &&
      !this.couponExists &&
      (this.isWorkshop ||
        (this.isRentals &&
          numberRentalProductsToQualify &&
          minimumRentalSpendToQualify &&
          (this.coupon.applyToRentalProducts ||
            this.coupon.applyToRentalAccessories)))
    );
  }

  save() {
    this.saving = true;

    if (this.linkedToParent) {
      this.coupon.partnerParentID = this.partner.ParentID;
      this.coupon.linkToServiceTypes = false;
    }

    if (this.coupon.type === 'FIXED_VALUE') {
      this.coupon.percentValue = 0;
    } else {
      this.coupon.fixedValue = 0;
    }

    if (this.coupon.linkToServiceTypes) {
      this.coupon.linkedServiceTypes = this.selectedServiceTypes.map((item) => {
        return { ServiceTypeID: item };
      });
    } else {
      this.coupon.linkedServiceTypes = [];
    }
    if (this.coupon.linkedToProductCategories) {
      this.coupon.linkedProductCategories = this.selectedProductCategories.map(
        (item) => {
          return { ProductCategory: item.value };
        },
      );
    } else {
      this.coupon.linkedProductCategories = [];
    }

    if (this.coupon.linkedToRentalCategories) {
      this.coupon.couponRentalCategories = this.selectedRentalCategories.map(
        (item) => {
          return { CategoryID: item };
        },
      );
    } else {
      this.coupon.couponRentalCategories = [];
    }

    if (this.coupon.linkedToRentalAccessoryCategories) {
      this.coupon.couponRentalAccessoryCategories =
        this.selectedRentalAccessoryCategories.map((item) => {
          return { CategoryID: item };
        });
    } else {
      this.coupon.couponRentalAccessoryCategories = [];
    }

    if (this.coupon.linkToAffiliates) {
      this.coupon.couponAffiliates = this.selectedRentalAffiliates.map(
        (item) => {
          return { AffiliateID: item };
        },
      );
    } else {
      this.coupon.couponAffiliates = [];
    }
    if (this.coupon.specifySpecificDays) {
      this.coupon.couponSpecificDays = this.selectedRentalDays.map((item) => {
        return { DayOfWeek: item };
      });
    } else {
      this.coupon.couponSpecificDays = [];
    }

    if (!this.limitDate) {
      this.coupon.expiryDate = null;
    }
    if (!this.limitUsage) {
      this.coupon.usageTimes = 0;
    }
    if (this.coupon.expiryDate) {
      this.coupon.expiryDate = moment(this.coupon.expiryDate).format(
        'YYYY-MM-DDT23:59',
      );
    }

    if (this.editing) {
      this.updateCoupon();
    } else {
      this.createCoupon();
    }
  }

  expireCoupon() {
    this.confirmationService.confirm({
      key: 'add_edit_coupons',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant('general.confirm'),
      message: this.translate.instant('bikeshop.coupons.expire_message'),
      accept: () => {
        this.coupon.expired = true;
        this.save();
      },
    });
  }

  createCoupon() {
    if (this.isRentals) {
      this.couponsService.createRentalsCoupon(this.coupon).subscribe(
        (coupon) => {
          this.saving = false;
          this.editing = true;
          this.coupon = coupon;
          //this.getFullDetail();
          this.messageService.add({
            key: 'coupon-toast',
            life: 10000,
            detail: this.translate.instant('bikeshop.coupons.coupon_created', {
              couponCode: coupon.couponCode,
            }),
          });
          this.close.emit();
        },
        (err) => {
          this.saving = false;
        },
      );
    } else {
      this.couponsService.createCoupon(this.coupon).subscribe(
        (coupon) => {
          this.saving = false;
          this.editing = true;
          this.coupon = coupon;
          //this.getFullDetail();
          this.messageService.add({
            key: 'coupon-toast',
            life: 10000,
            detail: this.translate.instant('bikeshop.coupons.coupon_created', {
              couponCode: coupon.couponCode,
            }),
          });
          this.close.emit();
        },
        (err) => {
          this.saving = false;
        },
      );
    }
  }

  updateCoupon() {
    if (this.isRentals) {
      this.couponsService.updateRentalsCoupon(this.coupon).subscribe(
        (coupon) => {
          this.saving = false;
          this.coupon = coupon;
          //this.getFullDetail();
          if (this.coupon.expired) {
            this.messageService.add({
              key: 'coupon-toast',
              life: 10000,
              detail: this.translate.instant(
                'bikeshop.coupons.coupon_expired',
                {
                  couponCode: coupon.couponCode,
                },
              ),
            });
            this.close.emit();
          } else {
            this.messageService.add({
              key: 'coupon-toast',
              life: 5000,
              detail: this.translate.instant('bikeshop.coupons.coupon_updated'),
            });
            this.close.emit();
          }
        },
        (err) => {
          this.saving = false;
        },
      );
    } else {
      this.couponsService.updateCoupon(this.coupon).subscribe(
        (coupon) => {
          this.saving = false;
          this.coupon = coupon;
          //this.getFullDetail();
          if (this.coupon.expired) {
            this.messageService.add({
              key: 'coupon-toast',
              life: 10000,
              detail: this.translate.instant(
                'bikeshop.coupons.coupon_expired',
                {
                  couponCode: coupon.couponCode,
                },
              ),
            });
            this.close.emit();
          } else {
            this.messageService.add({
              key: 'coupon-toast',
              life: 5000,
              detail: this.translate.instant('bikeshop.coupons.coupon_updated'),
            });
            this.close.emit();
          }
        },
        (err) => {
          this.saving = false;
        },
      );
    }
  }

  removeUser(index) {
    this.coupon.linkedUsers.splice(index, 1);
  }

  addUser(user) {
    if (this.coupon.linkedUsers === null) {
      this.coupon.linkedUsers = [];
    }
    this.coupon.linkedUsers.push({
      userID: user.ID,
      name: user.Name,
      surname: user.Surname,
      email: user.Email,
      phoneNumber: user.PhoneNumber,
    });
    this.showAddUser = false;
  }

  lightSpeedDiscountSelected(event) {
    if (this.coupon.type === 'FIXED_VALUE') {
      var discountValue = this.lightSpeedDiscountOpitons
        .filter((x) => {
          return x.value === event.value;
        })
        .pop().discountAmount;
      this.coupon.fixedValue = discountValue;
    } else if (this.coupon.type === 'PERCENT') {
      var percentValue = this.lightSpeedDiscountOpitons
        .filter((x) => {
          return x.value === event.value;
        })
        .pop().discountPercent;
      this.coupon.percentValue = percentValue * 100;
    }
    console.log(this.coupon);
  }

  getLightSpeedDiscountOpitons() {
    if (this.coupon.type === 'FIXED_VALUE') {
      return this.lightSpeedDiscountOpitons.filter((x) => {
        return x.discountAmount !== 0;
      });
    } else if (this.coupon.type === 'PERCENT') {
      return this.lightSpeedDiscountOpitons.filter((x) => {
        return x.discountPercent !== 0;
      });
    } else {
      return this.lightSpeedDiscountOpitons;
    }
  }

  //=====================================================================================================

  changeTab(i) {
    this.tab = i;
  }

  resetWizard() {
    this.invalidFileFormat = false;
    this.hasValidationErrors = false;
    this.keys = [];
    this.data = [];
    this.step = 1;
    this.sheetData = [];
  }

  prepareFile(evt) {
    let data, header;

    const target: DataTransfer = <DataTransfer>evt.target;
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      data = XLSX.utils.sheet_to_json(ws, { raw: false, defval: null });
    };

    reader.readAsBinaryString(target.files[0]);

    reader.onloadend = (e) => {
      this.keys = Object.keys(data[0]);
      this.dataSheet.next(data);
      /*this.dataSheet.subscribe(sheetData=>{
                          this.processFile(sheetData);
                        });*/
      this.processFile(data);
    };
    this.fileUpload.nativeElement.value = '';
  }

  processFile(data) {
    this.data = data;
    this.invalidFileFormat = false;
    this.hasValidationErrors = false;
    //this.startDate = null;
    console.log(this.keys);
    console.log(data);
    console.log(this.columns);
    //if (this.keys.indexOf("Customer Name") > -1 && this.keys.indexOf("Customer Surname") > -1 && this.keys.indexOf("Customer Email") > -1 && this.keys.indexOf("Customer Phone Number") > -1 && this.keys.indexOf("Bike Manufacturer") > -1) {

    this.step = 2;
    console.log(this.lightSpeedDiscountOpitons);

    data.forEach((row) => {
      var sts =
        row['Redeem Method'] !== '' &&
        row['Redeem Method'] !== null &&
        row['Use Before'] !== '' &&
        row['Use Before'] !== null &&
        row['Amount'] !== '' &&
        row['Amount'] !== null
          ? 'Valid'
          : 'Invalid';

      if (this.partner.POSSystemID === 6) {
        try {
          //if (row.Type === "FIXED_VALUE") {
          var ls = this.lightSpeedDiscountOpitons;
          var discountValue = ls.find((x) => x.discountAmount == row['Amount']);
          var LightSpeedDiscountID = discountValue.ID;
          //} else if (row.Type === "PERCENT") {
          //  var percentValue = this.lightSpeedDiscountOpitons.find(x => x.DiscountPercent == row.PercentValue);
          //  row.LightSpeedDiscountID = percentValue.ID;
          //}
        } catch (ex) {
          sts = 'Invalid';
        }
      }

      this.sheetData.push({
        couponCode: row['Coupon Code'] == null ? '' : row['Coupon Code'],
        couponDescription:
          row['Coupon Description'] == null ? '' : row['Coupon Description'],
        linkedToParent: row['Use Everywhere'] == 'Yes' ? true : false,
        redeemMethod: row['Redeem Method'],
        value: row['Amount'],
        linked:
          row['Link to user'] == 'Yes'
            ? row['Linked User Email'] == null
              ? row['Linked User Phone']
              : row['Linked User Email']
            : '',
        linkedToUser: row['Link to user'] == 'Yes' ? true : false,
        linkedUserEmail:
          row['Linked User Email'] == null ? '' : row['Linked User Email'],
        linkedUserPhone:
          row['Linked User Phone'] == null ? '' : row['Linked User Phone'],
        expiryDate: row['Use Before'],
        usageLimit: row['Usage Limit'] == null ? '1' : row['Usage Limit'],
        singleUsePerCustomer:
          row['Limit To Single Use Per Customer'] == 'Yes' ? true : false,
        newClientsOnly: row['For New Clients Only'] == 'Yes' ? true : false,
        status: sts,
      });
    });

    console.log(this.sheetData);
  }

  beginImport() {
    this.step = 3;
    this.saving = true;
    var completedCount = 0;

    this.sheetData.forEach((row) => {
      if (row.status == 'Valid') {
        row.status = 'Importing';

        var obj: any = {};

        obj.PartnerID = this.partner.ID;
        obj.PartnerParentID = 0;
        obj.RedeemMethod =
          row.redeemMethod == 'Online Widget'
            ? 'WIDGET'
            : row.redeemMethod == 'Mobile App'
              ? 'APP'
              : 'ANY';
        obj.Type = 'FIXED_VALUE';
        obj.FixedValue = row.value;
        obj.PercentValue = 0;
        obj.LightSpeedDiscountID = null;
        obj.CouponCode = row.couponCode;
        obj.Description = row.couponDescription;
        obj.LimitUsagePerCustomer = row.singleUsePerCustomer;
        obj.LinkedToUser = row.linkedToUser;
        obj.LinkToServiceTypes = false;
        obj.LinkedToProductCategories = false;
        obj.ForNewClientsOnly = row.newClientsOnly;
        obj.ExpiryDate = moment(row.expiryDate).format('YYYY-MM-DDT23:59');
        obj.UsageTimes = row.usageLimit;
        obj.Expired = false;
        obj.LinkedServiceTypes = [];
        obj.LinkedUsers = [];
        obj.LinkedProductCategories = [];
        obj.Usage = [];

        if (row.linkedToParent) {
          obj.partnerParentID = this.partner.ParentID;
          obj.linkToServiceTypes = false;
        }

        if (row.linkedToUser) {
          obj.LinkedUsers.push({
            userID: 0,
            email: row.linkedUserEmail,
            phoneNumber: row.linkedUserPhone,
          });
        }

        if (this.partner.POSSystemID === 6) {
          try {
            if (obj.Type === 'FIXED_VALUE') {
              var ls = this.lightSpeedDiscountOpitons;
              var discountValue = ls.find(
                (x) => x.discountAmount == obj.FixedValue,
              );
              obj.LightSpeedDiscountID = discountValue.value;
            } else if (obj.Type === 'PERCENT') {
              var percentValue = this.lightSpeedDiscountOpitons.find(
                (x) => x.discountPercent == obj.PercentValue,
              );
              obj.LightSpeedDiscountID = percentValue.value;
            }
          } catch (ex) {
            row.status = 'Invalid';
          }
        }

        if (row.status !== 'Invalid')
          this.couponsService.createCoupon(obj).subscribe(
            (coupon) => {
              row.status = 'Imported';
              completedCount += 1;
              this.progress = (completedCount / this.sheetData.length) * 100;
              //this.messageService.add({ key: 'coupon-toast', life: 3000, detail: this.translate.instant('bikeshop.coupons.coupon_created', { couponCode: coupon.couponCode }) });
              if (completedCount == this.sheetData.length) this.close.emit();
            },
            (err) => {
              row.status = 'Invalid';
              this.saving = false;
            },
          );
      }
    });
  }
}
